import { useParams } from 'react-router-dom';

import { useHeader } from 'context';
import { mapQuery } from 'utils/query';
import { useTitle, useOnceLoader } from 'hooks';
import { useDetailsQuery } from 'store/api/event';
import { Details, EventDetails } from 'components';

import { CreateReportDialog } from './report';

export const DetailsPage = () => {
  const { id } = useParams();

  const { data, ...props } = useDetailsQuery(id!, { skip: !id });

  useTitle('Event', data?.name ?? '');

  useHeader({ pageName: 'Event', showBackButton: true });

  const { isLoading } = useOnceLoader(props);

  return (
    <Details {...mapQuery(props)} isLoading={isLoading}>
      <EventDetails
        data={data}
        titleRightSlot={<CreateReportDialog event={data!} />}
      />
    </Details>
  );
};
